import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from '../shared/api.service';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private api: ApiService) { }

  public getDps(): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/delivery-platforms`, `admin`)
    return rtn;
  }

  // public getTenants(): Observable<any> {
  //   var rtn = this.api.get(`/api/v1/hq/outlet`, `admin`)
  //   return rtn;
  // }

  public getAllOutletsRelatedFranchise(franchise_id, keyword): Observable<any> {
    return this.api.get(`/api/v1/hq/franchise/outlets/${franchise_id}?q=${keyword}`, `admin`)
  }

  public getTenantsforUser(): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/user/admin/tenants`, `admin`)
    return rtn;
  }

  public getFranchises(): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/franchise`, `admin`)
    return rtn;
  }

  public getAllLocations(keyword): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/franchise?q=${keyword}`, `admin`)
    return rtn;
  }

  public createFranchise(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/franchise`, data, `admin`)
    return rtn;
  }

  public editFranchise(id: Number, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/franchise/${id}`, data, `admin`)
    return rtn;
  }

  public deleteFranchise(id: Number): Observable<any> {
    var rtn = this.api.delete(`/api/v1/hq/franchise/${id}`, `admin`)
    return rtn;
  }

  public getShop(id: Number): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/outlet/${id}`, `admin`)
    return rtn;
  }

  public createShop(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/outlet`, data, `admin`)
    return rtn;
  }

  public editShop(id: Number, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/outlet/${id}`, data, `admin`)
    return rtn;
  }

  public updateReceiptCount(id: Number, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/outlet/${id}/update-receipt-count`, data, `admin`)
    return rtn;
  }


  public deleteShop(id: Number): Observable<any> {
    var rtn = this.api.delete(`/api/v1/hq/outlet/${id}`, `admin`)
    return rtn;
  }

  public updateScheduleOrder(id: Number, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/outlet/test-order-status/${id}/${data}`, {}, `admin`)
    return rtn;
  }

  public getCommonBrandDetails(): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/master`, `admin`)
    return rtn;
  }

  public addCommonBrandDetails(id: any, data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/master`, data, `admin`)
    return rtn;
  }

  public updateCommonBrandDetails(id: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/master/${id}`, data, `admin`)
    return rtn;
  }

  public getMultipleTokens(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/tenants/get_tenants_tokens`, { tenants: data }, `admin`)
    return rtn;
  }

  public updateMultipleAllow(data): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/master/enable_multiple`, { value: data }, `admin`)
    return rtn;
  }

  public deleteTheme(id: Number): Observable<any> {
    var rtn = this.api.delete(`/api/v1/theme/${id}`, `admin`)
    return rtn;
  }

  // public getShops(): Observable<any> {
  //   var rtn = this.api.get(`/api/v1/hq/outlet`, `admin`)
  //   return rtn;
  // }

  public getShopById(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/outlet/${id}`, `admin`)
    return rtn;
  }

  public getShopByBrand(outlet: any, brand: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/outlet/${outlet}?b=${brand}`, `admin`)
    return rtn;
  }

  public getDeliveryDistanceById(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/outlet/delivery-distance/${id}`, `admin`)
    return rtn;
  }

  public getDistanceById(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/outlet/delivery-distance/${id}`, `admin`)
    return rtn;
  }

  public getOpenCloseById(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/outlet/open-close/${id}`, `admin`)
    return rtn;
  }

  public getOpenCloseByBrand(shopId: any, brandId: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/outlet/open-close/${shopId}?b=${brandId}`, `admin`)
    return rtn;
  }

  public updateOpenClose(data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/outlet/open-close`, data, `admin`)
    return rtn;
  }

  public updateDistance(data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/outlet/distance`, data, `admin`)
    return rtn;
  }

  public updateMenu(data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/outlet/update-defaultmenu`, data, `admin`)
    return rtn;
  }

  public getDiscountPromotionByShopId(brandID: any, shopID: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/outlet/promotion/brand/${brandID}/shop/${shopID}`, `admin`)
    return rtn;
  }

  public createDiscountPromotion(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/outlet/promotion`, data, `admin`)
    return rtn;
  }

  public changePromotion(data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/outlet/promotion`, data, `admin`)
    return rtn;
  }

  public setShopDiscounts(data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/outlet/discount`, data, `admin`)
    return rtn;
  }

  public setFirstOrderPromotion(data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/outlet/first-order-offer`, data, `admin`)
    return rtn;
  }

  // Payment Method Selection
  public updatePaymentShopMethods(shopid: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/outlet/${shopid}/update-payment-method`, data, `admin`)
    return rtn;
  }

  //Vouchers
  public getAllVouchers(): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/voucher`, `admin`)
    return rtn;
  }

  public getAllVouchersByBrand(brandId: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/voucher?brand_id=${brandId}`, `admin`)
    return rtn;
  }

  public getAllVouchersByBrandPagination(brandId: any, nextPage: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/voucher?brand_id=${brandId}&page=${nextPage}`, `admin`)
    return rtn;
  }

  public getAllVouchersByOutlet(outletId: any, brandId: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/voucher/outlet/${outletId}?brand_id=${brandId}`, `admin`)
    return rtn;
  }

  public getAllVouchersByOutletPagination(outletId: any, brandId: any, nextPage: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/voucher/outlet/${outletId}?brand_id=${brandId}&page=${nextPage}`, `admin`)
    return rtn;
  }

  public createVoucher(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/voucher/create-voucher`, data, `admin`)
    return rtn;
  }

  public updateVoucher(id: any, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/voucher/${id}`, data, `admin`)
    return rtn;
  }

  public deleteVoucher(id: any): Observable<any> {
    var rtn = this.api.delete(`/api/v1/hq/voucher/${id}`, `admin`)
    return rtn;
  }

  // shop fee
  public getShopFeeByShopId(brandId: any, shopId: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/webshop-brand/${brandId}/outlet/${shopId}/shop-fee`, `admin`)
    return rtn;
  }

  public getShopFeeForId(feeId: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/shop-fee/${feeId}`, `admin`)
    return rtn;
  }

  public createShopFee(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/shop-fee`, data, `admin`)
    return rtn;
  }

  public updateShopFee(feeId: any, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/shop-fee/${feeId}`, data, `admin`)
    return rtn;
  }

  public deleteShopFee(feeId: any): Observable<any> {
    var rtn = this.api.delete(`/api/v1/hq/shop-fee/${feeId}`, `admin`)
    return rtn;
  }

  //update webshop outlet setup status
  public updateWebshopStatus(brandId: any, outletId: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/webshop-brand/${brandId}/outlet/${outletId}/update-webshop-status`, data, `admin`)
    return rtn;
  }

  public getAdminUser(): Observable<any> {
    return this.api.get(`/api/v1/hq/user/current`, `admin`)
  }

  public getAdmins(): Observable<any> {
    return this.api.get(`/api/v1/hq/user/admin`, `admin`)
  }

  public getAllFranchises(): Observable<any> {
    return this.api.get(`/api/v1/hq/franchise`, `admin`)
  }

  public getShopsRelatedFranchise(franchise_id): Observable<any> {
    return this.api.get(`/api/v1/hq/franchise/outlets/${franchise_id}`, `admin`)
  }

  public getOutlets(): Observable<any> {
    return this.api.get(`/api/v1/hq/outlet`, `admin`)
  }

  public getTenantToken(selectedTenant: any): Observable<any> {
    return this.api.get(`/api/v1/hq/tenants/get_tenant_token/${selectedTenant}`, `admin`)
  }

  public getOrderCommission(brand: any, outlet: any): Observable<any> {
    return this.api.get(`/api/v1/hq/webshop-brand/${brand}/outlet/${outlet}/commission`, `admin`)
  }

  public updateTableReservationCommission(outlet: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/outlet/${outlet}/update-table-reservation-commission`, data, `admin`)
    return rtn;
  }

  public updateOrderCommission(brand: any, outlet: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/webshop-brand/${brand}/outlet/${outlet}/update-commission`, data, `admin`)
    return rtn;
  }

  public getInvoices(type: any, search: any, page_number: any): Observable<any> {
    return this.api.get(`/api/v1/hq/invoice?type=${type}&page=${page_number}&q=${search}`, `admin`)
  }

  public getInvoicePdf(id: any): Observable<any> {
    return this.api.getFiles(`/api/v1/hq/invoice/${id}/pdf`, `admin`).pipe(map((res: any) => {
      return new Blob([res], { type: 'application/pdf' })
    })
    )
  }

  public createInvoice(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/invoice`, data, `admin`)
    return rtn;
  }

  public sendInvoice(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/invoice/send`, data, `admin`)
    return rtn;
  }

  public deleteInvoice(id: any): Observable<any> {
    var rtn = this.api.delete(`/api/v1/hq/invoice/${id}`, `admin`)
    return rtn;
  }

  public updateInvoice(id: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/invoice/${id}`, data, `admin`)
    return rtn;
  }

  public getTableOrderNote(brand_id: any, shop_id: any,): Observable<any> {
    return this.api.get(`/api/v1/webshop-brand/${brand_id}/outlet/${shop_id}/table-order-note`, `admin`)
  }

  public updateTableOrderNote(brand_id: any, shop_id: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/webshop-brand/${brand_id}/outlet/${shop_id}/update-table-order-note`, data, `admin`)
    return rtn;
  }

  public getConnectAccounts(brand_id: any,): Observable<any> {
    return this.api.get(`/api/v1/hq/webshop-brand/${brand_id}/connect-account`, `admin`)
  }

  public createConnectAccount(brand_id: any, data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/webshop-brand/${brand_id}/connect-account`, data, `admin`)
    return rtn;
  }

  public generateConnectLink(brand_id: any, data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/webshop-brand/${brand_id}/connect-account/link`, data, `admin`)
    return rtn;
  }

  public deleteConnectAccount(brand_id: any, id: any): Observable<any> {
    var rtn = this.api.delete(`/api/v1/hq/webshop-brand/${brand_id}/connect-account/${id}`, `admin`)
    return rtn;
  }

  public updateGooglePlaceId(brand_id: any, shop_id: any, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/webshop-brand/${brand_id}/outlet/${shop_id}/update-address-details`, data, `admin`)
    return rtn;
  }

  public updateLoyaltyInfo(brand: string, data: any): Observable<any> {
    return this.api.put(`/api/v1/hq/webshop-brand/${brand}/update-loyalty`, data, `admin`)
  }

  public getShopCpPoints(shop_id: any,): Observable<any> {
    return this.api.get(`/api/v1/hq/outlet/${shop_id}/collection-point`, `admin`)
  }

  public createCollectionPoint(shop_id: any, data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/outlet/${shop_id}/collection-point`, data, `admin`)
    return rtn;
  }

  public updateCollectionPoint(shop_id: any, cpId: any, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/outlet/${shop_id}/collection-point/${cpId}`, data, `admin`)
    return rtn;
  }

  public deleteCollectionPoint(shop_id: any, cpId: any): Observable<any> {
    var rtn = this.api.delete(`/api/v1/hq/outlet/${shop_id}/collection-point/${cpId}`, `admin`)
    return rtn;
  }

  public updateCollectionPointStatus(shop_id: string, status: string): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/outlet/${shop_id}/collection-point/status/${status}`, {}, `admin`)
    return rtn;
  }

  public getShopCpPointsNotes(shop_id: any,): Observable<any> {
    return this.api.get(`/api/v1/hq/outlet/${shop_id}/collection-point/note`, `admin`)
  }


  public createUpdateCollectionPointNotes(shop_id: any, data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/outlet/${shop_id}/collection-point/note`, data, `admin`)
    return rtn;
  }

  // Delivery Point
  public getShopDpPoints(shop_id: any): Observable<any> {
    return this.api.get(`/api/v1/outlet/${shop_id}/delivery-points`, `admin`)
  }

  public createDeliveryPoint(shop_id: any, data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/outlet/${shop_id}/delivery-point`, data, `admin`)
    return rtn;
  }

  public updateDeliveryPoint(shop_id: any, cpId: any, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/outlet/${shop_id}/delivery-point/${cpId}`, data, `admin`)
    return rtn;
  }

  public deleteDeliveryPoint(shop_id: any, cpId: any): Observable<any> {
    var rtn = this.api.delete(`/api/v1/hq/outlet/${shop_id}/delivery-point/${cpId}`, `admin`)
    return rtn;
  }

  public updateDeliveryPointStatus(shop_id: string, status: string): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/outlet/${shop_id}/delivery-point/status/${status}`, {}, `admin`)
    return rtn;
  }

  public createUpdateDeliveryPointNotes(shop_id: any, data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/outlet/${shop_id}/delivery-point/note`, data, `admin`)
    return rtn;
  }


  public createUpdateTableOrderMethods(brand_id: any, shop_id: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/webshop-brand/${brand_id}/outlet/${shop_id}/table-order-methods`, data, `admin`)
    return rtn;
  }

  public getTableOrderMethods(brand_id: any, shop_id: any,): Observable<any> {
    return this.api.get(`/api/v1/webshop-brand/${brand_id}/outlet/${shop_id}/table-order-methods`, `admin`)
  }

  public getMaster(): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/master`, `admin`)
    return rtn;
  }

  public getCustomers(brand_id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/webshop-brand/${brand_id}/customers`, `admin`)
    return rtn;
  }

  public updateDeliverooVersion(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/master/update-deliveroo-version`, data, `admin`)
    return rtn;
  }

  public getCampaignDetails(): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/promotion-campaign?paginate=false`, `admin`)
    return rtn;
  }

  public updateContactDetails(brand_id: string, shop_id: string, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/webshop-brand/${brand_id}/outlet/${shop_id}/update-contact-details`, data, `admin`)
    return rtn;
  }


  public updatePayHereAccessToken(data: any, brand_id: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/payhere/access-token`, data, `admin`)
    return rtn;
  }
}
